import { Component, OnDestroy } from '@angular/core';
import { TariffSelectionService } from './tariff-selection.service';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { tvSizes, videoSizes } from '../../../../../examinationResult.model';
import { BroadcasterTypeSelectorComponent } from './broadcaster-type-selector/broadcaster-type-selector.component';

@Component({
  selector: 'app-tariff-selection',
  imports: [
    MatCheckbox,
    MatFormField,
    MatIcon,
    MatLabel,
    MatOption,
    MatSelect,
    TranslatePipe,
    FormsModule,
    BroadcasterTypeSelectorComponent,
  ],
  templateUrl: './tariff-selection.component.html',
  styleUrl: './tariff-selection.component.scss',
  providers: [TariffSelectionService],
})
export class TariffSelectionComponent implements OnDestroy {
  tvSizes = tvSizes;
  videoSizes = videoSizes;
  tvQuantities = new Array<number>(10).fill(0).map((_, i) => i + 1);

  constructor(protected tariffSelectionService: TariffSelectionService) {
    tariffSelectionService.updateErrorListService();
  }

  ngOnDestroy(): void {
    this.tariffSelectionService.errorListService.removeAllErrors();
  }
}
